

const Joi = require('joi');
import { HOST_CMS } from "common-import/constants";
import { Request } from "common-import/helpers";
// import * as Validator from "./Rating.Validator.js"

class NewsAPI {

  getListTestimonial = async (query) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader(HOST_CMS + "/testimonials", query);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  termsAndPolicies = async () => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader(HOST_CMS + "/simplepages", { id: '5c24476a30849b4ed70c313b' });
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  getNews = async (query = {}) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader(HOST_CMS + "/news", query);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  getJobs = async (query = {}) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader(HOST_CMS + "/careers", query);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  getRelatedArticleContractor = async () => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader("http://vietnamconstruction.vn/wp-json/wp/v2/posts", { tags: 115 });
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  getFeatureMemberLogo = async () => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader(HOST_CMS + "/settings", { id: "5c2c3de4affeb272487dd778" });
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  getImageHomePage = async () => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader(HOST_CMS + "/settings", { id: "5c2dc23daffeb272487dd77a" });
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  getTutorials = async (query) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader(HOST_CMS + "/tutorials", query);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  getBanUserAdmin = async () => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.getNoHeader(HOST_CMS + "/settings", { id: '5c3553f11be2e21ad70dfee8' });
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

}
export default new NewsAPI();



// WEBPACK FOOTER //
// ./src/services/news/News.API.js